<footer class="footer">
    <div class="footer__text">&copy; {{currentYear}} Woodgrove - All Rights Reserved</div>
</footer>